import { render } from "./fileTreePathSelector.vue?vue&type=template&id=bca744d8&ts=true"
import script from "./fileTreePathSelector.vue?vue&type=script&lang=ts"
export * from "./fileTreePathSelector.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__